export default __webpack_public_path__ + "static/connections-5bd0c778271b4ceac1c691e280670eb9.png";